import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "divider-wrapper" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Divider = _resolveComponent("Divider")
  const _component_ReasoningItem = _resolveComponent("ReasoningItem")
  const _component_CollapseGroup = _resolveComponent("CollapseGroup")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Collapse = _resolveComponent("Collapse")

  return (_openBlock(), _createBlock(_component_Collapse, {
    onAfterEnter: $options.afterEnter,
    onBeforeLeave: _cache[1] || (_cache[1] = $event => ($data.show_thumb = false))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["reasoning-content", {'show-thumb': $data.show_thumb}])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Divider, {
            vertical: "",
            bg: "var(--brand-100)"
          })
        ]),
        _createVNode(_component_ScrollBar, {
          ref: "scroller",
          class: "scroller",
          "max-height": "34.8rem"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CollapseGroup, {
              items: $props.items,
              duration: 300,
              gap: "0.8rem",
              onBeforeEnter: _cache[0] || (_cache[0] = $event => ($options.checkBottom())),
              onAfterEnter: $options.onNewItem
            }, {
              default: _withCtx(({item, index}) => [
                _createVNode(_component_ReasoningItem, {
                  ref: index === $props.items.length - 1 ? 'last_reasoning_item' : undefined,
                  item: item,
                  current: !$props.completed && index === $props.items.length - 1,
                  "initial-open": !$props.completed && (index === $props.items.length - 1),
                  onExpanded: $options.scrollToItem
                }, null, 8 /* PROPS */, ["item", "current", "initial-open", "onExpanded"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["items", "onAfterEnter"])
          ]),
          _: 1 /* STABLE */
        }, 512 /* NEED_PATCH */)
      ], 2 /* CLASS */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onAfterEnter"]))
}